module.exports = __webpack_public_path__ + "09bae677a1b86cd1309f4eb3de0314f3.png";